// // if using for ui-header and/or ui-footer
// // otherwise, leave empty as a placeholder for webpack
import React from 'react';
import { render } from 'react-dom';
import dynamicModuleRegistery from 'dynamic-module-registry';
import 'ui-header';
import Footer from '../rc-footer';

if (document.getElementById('pl-footer')) {
  const footerContext = dynamicModuleRegistery.get('footerContext') || {};
  render(<Footer footerContext={footerContext} />, document.getElementById('pl-footer'));
}

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/shared_modules/local-propulsion/core/styles.scss');